import { Branding } from '../Branding';
import getReadyLogo from '../../assets/get-ready-logo-no-tagline_teal.svg';

export const getReadyBranding: Branding = {
  name: 'GetReady',
  logo: getReadyLogo,
  orgEmail: 'info@getready.es',
  orgPhone: '+34 91 564 01 62',
  privacyPolicyUrl: 'https://getready.es/politicaprivacidad/',
  defaultLocale: 'es',
  withPayment: false,
};
